import React from "react";

import { ButtonLoading, ButtonLoadingProps } from "../../../../../atoms/ButtonLoading";
// context
import { usePyForm } from "../../../context";

export type SubmitButtonProps = Omit<ButtonLoadingProps, "loading"> & {
	/**
	 * The meta data to be passed to the onSubmit function within the PYForm component context. This is helpful if there are multiple onSubmit buttons, and therefore multiple onSubmit functional logics that need ot be supported.
	 */
	onSubmitMeta?: Record<string, unknown>;
	/**
	 * Optional loading state. If not provided, will use the form's submitting state.
	 */
	loading?: boolean;
};

// This is a reusable component that is used to submit the form
// it is used to submit the form and is disabled if the form is not dirty or if the form is submitting
// it also shows a loading state if the form is submitting
export const SubmitButton = ({ onSubmitMeta, ...props }: SubmitButtonProps) => {
	const form = usePyForm();
	return (
		<form.Subscribe selector={(state) => [state.isSubmitting, state.canSubmit, state.isDirty]}>
			{([isSubmitting]) => (
				<ButtonLoading
					{...props}
					type="submit"
					disabled={isSubmitting || props.disabled}
					data-testid={`${form.id}-submit-button`}
					loading={isSubmitting || (props.loading ?? false)}
					loadingText={props?.loadingText ? props.loadingText : undefined}
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						props.onClick?.(e);
						form.submit(onSubmitMeta || {});
					}}
				>
					{props.children}
				</ButtonLoading>
			)}
		</form.Subscribe>
	);
};

export default SubmitButton;
